import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { PodiumService }            from './podium.service';
import { PodiumSettingsComponent }  from './podium.settings.component';
import { PodiumSettingsModel }      from './typings/podium.settings.model';

export const PodiumStates : Array<NgHybridStateDeclaration> = [
  {
    component: PodiumSettingsComponent,
    name     : 'app.podium-settings',
    resolve  : [
      {
        deps     : [ PodiumService ],
        resolveFn: ( podiumService : PodiumService ) : Promise<CompanyIntegrationsModel> => podiumService.getIntegrations(),
        token    : 'integrations'
      },
      {
        deps     : [ PodiumService ],
        resolveFn: ( podiumService : PodiumService ) : Promise<PodiumSettingsModel> => podiumService.getSettings(),
        token    : 'settings'
      }
    ],
    url: '/podium-settings'
  }
];
